import { InjectionToken } from '@angular/core';


export interface HasReportId {
    reportId: string;
}

export const REPORT_TOKEN = new InjectionToken('ReportWindowComponent');


const arrayCompare = <T>(f: (a: T, b: T) => number, [x, ...xs]: T[], [y, ...ys]: T[]): number => {
    if (typeof x === 'undefined' && typeof y === 'undefined') {
        return 0;
    }
    const comp = f(x, y);
    if (comp !== 0) {
        return comp;
    }
    return arrayCompare(f, xs, ys);
};


const empty = <T>(x: T) => x === '' || x === null || typeof x === 'undefined';


type HasName = { name: any };

const hasName = <T>(x: T | HasName): x is HasName => typeof (x as HasName).name !== 'undefined';


const compare = <T>(a: T, b: T, orderReverse: boolean): number => {
    if (Array.isArray(a) && Array.isArray(b)) {
        return arrayCompare((x, y) => compare(x, y, orderReverse), a, b);
    }

    // link
    if (typeof a === 'object' && a !== null && hasName(a)) {
        a = a.name;
    }
    if (typeof b === 'object' && b !== null && hasName(b)) {
        b = b.name;
    }

    if (empty(a) && empty(b)) {
        return 0;
    }

    if (a < b || empty(a)) {
        return orderReverse ? 1 : -1;
    }
    if (a > b || empty(b)) {
        return orderReverse ? -1 : 1;
    }
    return 0;
};


export const compareFn = <T>(a: T, b: T, orderBy: keyof T, orderReverse: boolean) => compare(a[orderBy], b[orderBy], orderReverse);
